<div class="centering-container" *ngIf="!this.isErrored">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="this.isErrored" class="centering-container instruction error">
  <div>
    <mat-icon>error_outline</mat-icon>
  </div>
  <div>
    {{this.friendlyErrorMessage}}
  </div>
  <div class="fine-print">
    {{this.correctionAdvice}}
  </div>
  <div class="fine-print">
    <p>
      <a href="#" (click)="this.toggleExpanded($event)">{{ this.isExpanded ? 'hide' : 'show' }} error message</a>
    </p>
    <div *ngIf="this.isExpanded" class="fine-print">
      <div class="raw-error">
        {{this.rawErrorMessage}}
      </div>
    </div>
  </div>
</div>